import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as Options from '../../select-options';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-remove-service-modal',
  templateUrl: './remove-service-modal.component.html',
  styleUrls: ['./remove-service-modal.component.scss']
})
export class RemoveServiceModalComponent {

  modalTitle: string;
  serviceForm!: FormGroup;
  serviceCategories: any[] = []

  constructor(
    public dialogRef: MatDialogRef<RemoveServiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.modalTitle = data.modalTitle;
    this.serviceCategories = data.serviceCategories;
    this.serviceForm = this.fb.group({
      selectedService: ['', Validators.required]
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  submitForm() {
    // Handle form submission here
    if (this.serviceForm.valid) {
      this.dialogRef.close(this.serviceForm)
    }
  }

}
